import React from "react";
import { useNavigate } from "react-router-dom";

const BloqueioEvento = ({ tipo, mensagem, ano }) => {
    const navigate = useNavigate();

    return (
        <div className="alert alert-warning text-center mt-4">
            <p>{mensagem}</p>

            {tipo === 'ANUIDADE_PENDENTE' && (
                <button
                    className="btn-main color-2 mt-2"
                    onClick={() => navigate("/meu-painel")}
                >
                    Regularizar Anuidade
                </button>
            )}
        </div>
    );
};

export default BloqueioEvento;
